import type { Type } from '@warp-drive/core/types/symbols';
import { attr, hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Media from '@linc-technologies/linced-common/models/media';
import Post from './post';

export default class Globalnotice extends Post {
  declare [Type]: 'posts/globalnotice';

  postType = PostTypes.GLOBAL_NOTICE;

  // Global (Hero) Notices don't support comments/reactions.
  @attr()
  // @ts-expect-error A plain attr replaces the Post comments hasMany.
  declare comments: unknown;

  @attr()
  // @ts-expect-error A plain attr replaces the Post reactions hasMany.
  declare reactions: unknown;

  @hasMany('media', { async: true, inverse: 'globalNoticeId' })
  declare mediaIds: AsyncHasMany<Media>;

  // Don't trigger the Person reloads which the base Post model does.
  reloadPersonOnSave = false;
}
